import { validPhoneNumberExpression } from './consts/validPhoneNumberExpression'

export default function isValidPhoneNumber(phoneNumber: string): boolean {
    const phoneNumberWithoutWhitespace = phoneNumber
        ? phoneNumber.replace(/ /g, '')
        : ''

    return validPhoneNumberExpression.test(phoneNumberWithoutWhitespace)
}
